module.exports = __webpack_public_path__ + "static/img/16.4998324.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/16.png
// module id = zIv+
// module chunks = 0